/* nebe-sticky-atc.js: spodní lišta „Přidat do košíku" (snippet nebe-sticky-atc).
 *
 * Zdroj pravdy je stránka. Lišta si nedrží vlastní výběr: barvu, velikost i přidání
 * do košíku provede klikem na skutečné tlačítko v buyboxu (nebe-pdp.js) a pak se jen
 * překreslí podle toho, co stránka ukazuje. Multibuy, počet kusů, hlídací pes, boční
 * košík i chyby tak zůstávají jedny a tytéž.
 *
 * Stránka se sleduje MutationObserverem jen na pár uzlech (kolečka, velikosti, cena,
 * multibuy, stepper počtu kusů, tlačítko). Celý buybox ne: odpočet u ceny se přepisuje mnohokrát za vteřinu.
 * Kdy je lišta vidět, řeší IntersectionObserver na formuláři. Scroll listener žádný.
 *
 * Cookie lišta Pandectes má přednost (stejná logika jako nebe-promo-fly.js). Na rozhodnutí
 * se čeká 1s intervalem, který běží jen tehdy, když by lišta chtěla ven a nesmí.
 *
 * Idempotentní: druhé načtení souboru jen znovu zavolá boot.
 */
(function () {
  "use strict";

  if (window.NEBE_STICKY) { window.NEBE_STICKY.boot(); return; }

  var DESKTOP = "(min-width: 990px)";
  var CONSENT_GRACE_MS = 8000;
  var TICK_MS = 1000;
  var ADDED_MS = 1800;
  var TOAST_MS = 3200;
  var ADD_TIMEOUT_MS = 12000;
  // výchozí velikost, když zákaznice žádnou nevybrala: M, pak L, pak první dostupná
  var PREFERRED = ["M", "L"];
  var current = null;

  function arr(list) { return Array.prototype.slice.call(list || []); }

  // ---- cookie lišta Pandectes (stejná pravidla jako kartička akce) ----
  function shown(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity) > 0;
  }
  function cookieBannerShown() {
    var els = document.querySelectorAll(".cc-window");
    for (var i = 0; i < els.length; i++) {
      if (els[i].classList.contains("cc-invisible")) continue;
      if (shown(els[i])) return true;
    }
    return false;
  }
  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf("=");
      if (parts[i].slice(0, eq) === name) return parts[i].slice(eq + 1);
    }
    return null;
  }
  function sinceLoad() {
    try { if (window.performance && performance.now) return performance.now(); } catch (e) {}
    return CONSENT_GRACE_MS;
  }
  // Souhlas = base64 JSON s neprázdným status. Bez cookie po 8 s a bez viditelné lišty
  // Pandectes nejspíš neběží a čekat by znamenalo lištu nikdy neukázat.
  function consentGiven() {
    var raw = readCookie("_pandectes_gdpr");
    if (raw != null) {
      try {
        var data = JSON.parse(window.atob(decodeURIComponent(raw)));
        if (data && typeof data === "object" && "status" in data) return !!data.status;
      } catch (e) {}
    }
    return sinceLoad() >= CONSENT_GRACE_MS && !cookieBannerShown();
  }

  function Sticky(root) {
    var sid = root.getAttribute("data-section") || "";
    var page = document.querySelector(".nebe-pdp:not(.nebe-portal)");
    var atc = document.getElementById("ProductSubmitButton-" + sid);

    // Dárkový poukaz (vlastní formulář gc-form) a outlet lištu nemají. Liquid je sem
    // nepustí, tohle je pojistka pro případ, že by se snippet vykreslil jinde.
    if (!page || !atc || atc.closest(".gc-form") || page.classList.contains("is-outlet") ||
        !("IntersectionObserver" in window) || !("MutationObserver" in window)) {
      root.remove();
      return null;
    }

    // Na konec body: předek s transformací nebo vlastním z-indexem by rozbil position: fixed.
    document.body.appendChild(root);

    var T = function (k) { return root.getAttribute("data-t-" + k) || ""; };
    var $ = function (s) { return root.querySelector(s); };
    var mq = window.matchMedia ? window.matchMedia(DESKTOP) : { matches: false };
    var inner = $(".nebe-sticky-inner");
    var swWrap = $("[data-nebe-sticky-sw]");
    var sizesWrap = $("[data-nebe-sticky-sizes]");
    var dd = $("[data-nebe-sticky-dd]");
    var ddLabel = $("[data-nebe-sticky-ddlabel]");
    var addBtn = $("[data-nebe-sticky-add]");
    var addLabel = $("[data-nebe-sticky-label]");
    var nowEl = $("[data-nebe-sticky-now]");
    var oldEl = $("[data-nebe-sticky-old]");
    var cnameEl = $("[data-nebe-sticky-cname]");
    var thumb = $("[data-nebe-sticky-thumb]");
    var toastEl = $("[data-nebe-sticky-toast]");
    var live = $("[data-nebe-sticky-live]");
    var panels = { color: $('[data-nebe-sticky-panel="color"]'), size: $('[data-nebe-sticky-panel="size"]') };
    var clist = $("[data-nebe-sticky-clist]");
    var slist = $("[data-nebe-sticky-slist]");
    var guide = $("[data-nebe-sticky-guide]");

    // Počet kusů. Starší snippet (nebo stránka z cache) stepper v markupu nemá: dostaví se
    // tady, texty pak podle jazyka stránky.
    var SK = /^sk/i.test(document.documentElement.lang || "");
    var QTY_T = {
      "qty": SK ? "Počet kusov" : "Počet kusů",
      "qty-less": SK ? "Menej kusov" : "Méně kusů",
      "qty-more": SK ? "Viac kusov" : "Více kusů"
    };
    var Tq = function (k) { return T(k) || QTY_T[k]; };
    var qtyWrap = $("[data-nebe-sticky-qty]");
    if (!qtyWrap) {
      qtyWrap = el("span", "nebe-sticky-qty ignore-empty");
      qtyWrap.setAttribute("role", "group");
      qtyWrap.setAttribute("aria-label", Tq("qty"));
      qtyWrap.setAttribute("data-nebe-sticky-qty", "");
      qtyWrap.hidden = true;
      [["dec", "−", "qty-less"], ["val"], ["inc", "+", "qty-more"]].forEach(function (d) {
        var n;
        if (d[0] === "val") {
          n = el("span", "nebe-sticky-qval ignore-empty");
        } else {
          n = el("button", "nebe-sticky-qbtn");
          n.type = "button";
          n.textContent = d[1];
          n.setAttribute("aria-label", Tq(d[2]));
          n.setAttribute("data-key", "q" + d[0]);
        }
        n.setAttribute("data-nebe-sticky-" + (d[0] === "val" ? "qval" : d[0]), "");
        qtyWrap.appendChild(n);
      });
      // samostatná položka řady lišty, před tlačítkem (pořadí na desktopu řídí CSS order)
      inner.insertBefore(qtyWrap, addBtn);
    }
    var qtyDec = $("[data-nebe-sticky-dec]");
    var qtyInc = $("[data-nebe-sticky-inc]");
    var qtyVal = $("[data-nebe-sticky-qval]");

    var formWrap = atc.closest(".product-form") || atc;
    var atcOut = false, on = false, dead = false, consentOk = false, autoDone = false;
    var openPanel = null, opener = null, moreCount = 0;
    var tick = null, styleTimer = null, styleTries = 0, raf = 0;
    var addedTimer = null, toastTimer = null, pending = null;
    var io = null, io2 = null, mo = null, ro = null;
    var pickerIn = {}; // mobil: které výběry (barva, velikost) jsou právě na obrazovce

    // ---- čtení stavu stránky ----
    function pageQ(s) { return page.querySelector(s); }
    function pageSwatches() {
      var c = pageQ("[data-swatches]");
      return c ? arr(c.querySelectorAll("[data-i]")) : [];
    }
    function pageSizes() {
      var c = pageQ("[data-sizes]");
      return c ? arr(c.querySelectorAll("button")) : [];
    }
    function pressed(b) {
      return b.classList.contains("is-active") || b.getAttribute("aria-pressed") === "true";
    }
    function readColors() {
      return pageSwatches().map(function (b, i) {
        var dot = b.querySelector(".swatch__dot");
        var title = (b.getAttribute("title") || "").replace(/\s*\|\s*/, " · ").replace(/\s*·\s*$/, "");
        return {
          btn: b,
          i: i,
          bg: b.style.background || (dot && dot.style.background) || "#cfcfcf",
          name: title || (b.getAttribute("aria-label") || ""),
          aria: b.getAttribute("aria-label") || title,
          active: pressed(b),
          soldout: b.classList.contains("is-soldout")
        };
      });
    }
    function readSizes() {
      return pageSizes().map(function (b) {
        var label = (b.textContent || "").trim();
        return {
          btn: b,
          label: label,
          // „S (35–38)" u ponožek: do úzkého „▾" jen písmeno, celé znění ve výběru
          short: label.replace(/\s*\(.*\)\s*$/, "") || label,
          aria: b.getAttribute("aria-label") || label,
          active: pressed(b),
          soldout: b.classList.contains("is-soldout")
        };
      });
    }
    // Stepper počtu kusů v buyboxu. Číslo je v inputu [data-val]; jeho value mutaci
    // nevyvolá, proto se lišta překresluje i na click/change/focusout na stepperu (napojení dole).
    function pageQty() { return pageQ("[data-qty]"); }
    function readQty() {
      var q = pageQty();
      var inp = (q && q.querySelector("[data-val]")) || pageQ("[data-qty-input]");
      var n = inp ? parseInt(inp.value, 10) : NaN;
      return n > 0 ? n : 1;
    }
    function activeColorIndex(colors) {
      for (var i = 0; i < colors.length; i++) if (colors[i].active) return i;
      return 0;
    }
    function activeSize(sizes) {
      for (var i = 0; i < sizes.length; i++) if (sizes[i].active) return sizes[i];
      return null;
    }

    // ---- výchozí velikost: hned po načtení, jen když zákaznice nic nevybrala a URL nemá ?variant= ----
    // Klik na pilulku v nebe-pdp.js pošle měřicí size_select (A/B fit-hintu) a přepíše URL
    // na ?variant= přes history.replaceState. Předvýběr není volba zákaznice, takže po dobu
    // programového kliku size_select zahodíme (dataLayer i window.nebeTrack) a URL vrátíme.
    // Klik je synchronní (emit volá posluchače hned), obal tedy nic jiného nezachytí.
    function silentClick(btn) {
      var dl = window.dataLayer = window.dataLayer || [];
      var push = dl.push, nt = window.nebeTrack;
      var href = window.location.href, hs = window.history ? window.history.state : null;
      var isSel = function (o) { return o && typeof o === "object" && o.event === "nebe_size_select"; };
      dl.push = function () {
        var keep = arr(arguments).filter(function (o) { return !isSel(o); });
        return keep.length ? push.apply(dl, keep) : dl.length;
      };
      if (typeof nt === "function") {
        window.nebeTrack = function (ev) { if (ev === "size_select") return; return nt.apply(this, arguments); };
      }
      try { btn.click(); }
      finally {
        dl.push = push;
        if (typeof nt === "function") window.nebeTrack = nt;
        try {
          if (window.location.href !== href) window.history.replaceState(hs, "", href);
        } catch (e) {}
      }
    }
    function urlHasVariant() {
      try { return new URL(window.location.href).searchParams.has("variant"); } catch (e) { return false; }
    }
    function applyDefaultSize() {
      if (autoDone) return;
      var sizes = readSizes();
      if (!sizes.length) return;
      autoDone = true;
      if (activeSize(sizes) || urlHasVariant()) return;
      var pick = null;
      for (var p = 0; p < PREFERRED.length && !pick; p++) {
        for (var i = 0; i < sizes.length; i++) {
          if (!sizes[i].soldout && sizes[i].short.toUpperCase() === PREFERRED[p]) { pick = sizes[i]; break; }
        }
      }
      if (!pick) for (var j = 0; j < sizes.length; j++) if (!sizes[j].soldout) { pick = sizes[j]; break; }
      if (pick) silentClick(pick.btn);
    }

    // ---- vykreslení ----
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function dotFor(c) {
      var d = el("span", "nebe-sticky-dot");
      d.style.background = c.bg;
      return d;
    }
    function swatchBtn(c) {
      var b = el("button", "nebe-sticky-swb" + (c.soldout ? " is-soldout" : ""));
      b.type = "button";
      b.setAttribute("aria-label", c.aria);
      b.setAttribute("aria-pressed", String(c.active));
      b.title = c.name;
      b.setAttribute("data-key", "c" + c.i);
      b.appendChild(dotFor(c));
      b.addEventListener("click", function () { pickColor(c.i); });
      return b;
    }
    function sizeBtn(s, where) {
      var b = el("button", "nebe-sticky-size");
      b.type = "button";
      b.textContent = s.label;
      b.setAttribute("aria-label", s.aria);
      b.setAttribute("aria-pressed", String(s.active));
      // Na stránce vyprodaná velikost spouští hlídacího psa; v liště není co hlídat, proto nevolitelná.
      b.disabled = s.soldout;
      b.setAttribute("data-key", (where || "") + "s" + s.label);
      b.addEventListener("click", function () { pickSize(s.label); });
      return b;
    }

    function renderColors(colors) {
      root.classList.toggle("is-nocolor", colors.length < 2);
      swWrap.innerHTML = "";
      clist.innerHTML = "";
      moreCount = 0;
      if (colors.length < 2) return;
      var slot = parseFloat(getComputedStyle(root).getPropertyValue("--nebe-sticky-slot")) || 36;
      var slots = Math.max(2, Math.floor(swWrap.clientWidth / slot));
      var shownC = colors.slice();
      if (colors.length > slots) {
        shownC = colors.slice(0, slots - 1);
        // vybraná barva je v liště vždycky vidět, i když patří mezi schované
        var sel = activeColorIndex(colors);
        if (sel >= slots - 1) shownC[slots - 2] = colors[sel];
        moreCount = colors.length - shownC.length;
      }
      shownC.forEach(function (c) { swWrap.appendChild(swatchBtn(c)); });
      if (moreCount) {
        var m = el("button", "nebe-sticky-more", "<span>+" + moreCount + "</span>");
        m.type = "button";
        m.setAttribute("aria-label", T("more") + " (" + moreCount + ")");
        m.setAttribute("aria-haspopup", "dialog");
        m.setAttribute("aria-expanded", String(openPanel === "color"));
        m.setAttribute("data-key", "more");
        m.addEventListener("click", function () { toggle("color", m); });
        swWrap.appendChild(m);
      }
      colors.forEach(function (c) {
        var o = el("button", "nebe-sticky-copt" + (c.soldout ? " is-soldout" : ""));
        o.type = "button";
        o.setAttribute("aria-pressed", String(c.active));
        o.setAttribute("aria-label", c.aria);
        o.setAttribute("data-key", "o" + c.i);
        o.appendChild(dotFor(c));
        var t = el("span");
        t.textContent = c.name;
        o.appendChild(t);
        o.addEventListener("click", function () { pickColor(c.i); close(); });
        clist.appendChild(o);
      });
      if (openPanel === "color" && !moreCount) close();
    }

    function renderSizes(sizes) {
      root.classList.toggle("is-nosize", sizes.length < 2);
      sizesWrap.innerHTML = "";
      slist.innerHTML = "";
      sizes.forEach(function (s) {
        sizesWrap.appendChild(sizeBtn(s, "d"));
        slist.appendChild(sizeBtn(s, "p"));
      });
      var a = activeSize(sizes);
      ddLabel.textContent = a ? a.short : T("size");
      dd.setAttribute("aria-label", T("size") + ": " + (a ? a.label : "") + ", " + T("change"));
      if (guide) guide.hidden = !pageQ("[data-size-open]");
    }

    // Desktop: „− 4 +" v řadě před cenou místo šedého „4 kusy". Jen když stránka stepper má a je
    // vidět (u vyprodané velikosti stránka schová celý nákupní řádek, lišta pak taky ne).
    function renderQty() {
      var q = pageQty();
      var show = !!(q && q.querySelector("[data-inc]") && q.getClientRects().length);
      qtyWrap.hidden = !show;
      root.classList.toggle("has-qty", show);
      if (!show) return;
      var n = readQty();
      if (qtyVal.textContent !== String(n)) qtyVal.textContent = String(n);
      // Na 1 se dál nejde. Ne disabled: zaměřené tlačítko by ztratilo fokus.
      qtyDec.setAttribute("aria-disabled", String(n <= 1));
    }

    function renderPrice() {
      // Multibuy: přidává se tolik kusů, kolik je vybráno na stránce, takže cena za kus
      // podle tieru. „od 615 Kč" z hlavičky by u přímého přidání 4 kusů mátlo. Počet kusů
      // ukazuje stepper; šedé „4 kusy" jen tehdy, když stepper vidět není.
      var bundle = pageQ("[data-bundles] .bundle.is-active");
      if (bundle) {
        var amt = bundle.querySelector(".bundle__amt");
        var per = bundle.querySelector(".bundle__per");
        var qty = bundle.querySelector(".bundle__qty");
        nowEl.textContent = ((amt ? amt.textContent : "") + (per ? per.textContent : "")).replace(/\s+/g, " ").trim();
        oldEl.textContent = qty && qtyWrap.hidden ? qty.textContent.trim() : "";
        oldEl.classList.remove("is-struck");
        return;
      }
      var now = pageQ("[data-price-now]");
      var old = pageQ("[data-price-old]");
      nowEl.textContent = now ? now.textContent.trim() : "";
      var sale = !page.classList.contains("no-sale") && old && old.textContent.trim() &&
        old.textContent.trim() !== nowEl.textContent;
      oldEl.textContent = sale ? old.textContent.trim() : "";
      oldEl.classList.toggle("is-struck", !!sale);
    }

    function renderMeta(colors) {
      var cn = pageQ("[data-color-name]");
      cnameEl.textContent = cn ? cn.textContent.replace(/\s+/g, " ").trim() : "";
      // náhled ve vybrané barvě: první fotka galerie barvy (stejná data, ze kterých kreslí stránka)
      try {
        var P = window.PRODUCT;
        var g = P && P.colors && P.colors[activeColorIndex(colors)] && P.colors[activeColorIndex(colors)].gallery;
        var src = g && g[0] && g[0].img;
        if (src && thumb) {
          src = src.replace(/([?&]width=)\d+/, "$1112");
          if (thumb.getAttribute("src") !== src) thumb.setAttribute("src", src);
          thumb.hidden = false;
        }
      } catch (e) {}
    }

    function renderButton() {
      if (pending || addBtn.classList.contains("is-added")) return;
      var off = atc.disabled;
      addBtn.disabled = off;
      var lab = atc.querySelector(".label");
      var txt = off && lab ? lab.textContent.trim() : T("atc");
      addLabel.textContent = txt;
      addBtn.setAttribute("aria-label", txt);
    }

    // Tlačítka se při překreslení staví znovu; klávesnicové zaměření se nesmí ztratit.
    function focusKey() {
      var a = document.activeElement;
      return a && root.contains(a) ? a.getAttribute("data-key") : null;
    }
    function render() {
      raf = 0;
      if (dead) return;
      // předvýběr velikosti hned po načtení (nezávisle na liště a cookie liště); když
      // nebe-pdp.js ještě pilulky nevykreslil, zkusí se znovu při dalším překreslení
      if (!autoDone) applyDefaultSize();
      var fk = focusKey();
      var colors = readColors();
      renderColors(colors);
      renderSizes(readSizes());
      renderQty();
      renderPrice();
      renderMeta(colors);
      renderButton();
      if (fk && !root.contains(document.activeElement)) {
        var t = root.querySelector('[data-key="' + fk.replace(/"/g, "") + '"]');
        if (t) try { t.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(render);
    }

    // ---- akce: všechno je klik na stránce ----
    function pickColor(i) {
      var b = pageSwatches()[i];
      if (b && !pressed(b)) b.click();
    }
    function pickSize(label) {
      autoDone = true;
      var s = readSizes().filter(function (x) { return x.label === label; })[0];
      if (s && !s.soldout && !s.active) s.btn.click();
      if (openPanel === "size") close();
    }
    // − / +: klik na stepper stránky. Engine je synchronní (emit), nové číslo je tedy
    // v inputu hned po kliku. Nad skladem stránka číslo nezvýší, zatřese svým stepperem
    // (mimo obraz) a napíše hlášku do .toast: zatřese se i ten v liště a hláška se
    // zopakuje v toastu lišty. Čtečce ji oznámí už stránka (role=alert), proto bez say().
    function stepQty(dir) {
      var q = pageQty();
      var b = q && q.querySelector(dir > 0 ? "[data-inc]" : "[data-dec]");
      if (!b) return;
      var before = readQty();
      var t0 = document.querySelector(".toast");
      var mark = t0 && t0.firstChild;
      b.click();
      var after = readQty();
      if (after !== before) {
        say(Tq("qty") + ": " + after);
      } else if (dir > 0) {
        qtyWrap.classList.remove("is-shake");
        void qtyWrap.offsetWidth;
        qtyWrap.classList.add("is-shake");
        // engine přepisuje textContent, takže čerstvá hláška = nový textový uzel
        var t1 = document.querySelector(".toast");
        if (t1 && t1.firstChild && t1.firstChild !== mark) toast(t1.textContent.trim());
      }
      render();
    }

    // ---- panely nad lištou ----
    function toggle(name, trigger) {
      if (openPanel === name) { close(); return; }
      close(true);
      var p = panels[name];
      if (!p) return;
      openPanel = name;
      opener = trigger;
      p.hidden = false;
      if (mq.matches && trigger) {
        // desktop: panel nad tím, čím se otevřel, ale ne přes okraj obrazovky
        var r = trigger.getBoundingClientRect();
        var w = p.offsetWidth || 440;
        p.style.left = Math.max(12, Math.min(r.left, window.innerWidth - w - 12)) + "px";
      } else {
        p.style.left = "";
      }
      trigger.setAttribute("aria-expanded", "true");
      document.addEventListener("pointerdown", onOutside, true);
      var first = p.querySelector('[aria-pressed="true"]') || p.querySelector("button:not(:disabled)");
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
    function close(silent) {
      if (!openPanel) return;
      var p = panels[openPanel];
      if (p) p.hidden = true;
      openPanel = null;
      document.removeEventListener("pointerdown", onOutside, true);
      arr(root.querySelectorAll('[aria-expanded="true"]')).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      var o = opener;
      opener = null;
      if (!silent && o && o.isConnected && root.contains(document.activeElement)) {
        try { o.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    function onOutside(e) {
      if (!root.contains(e.target)) close(true);
    }
    function onKey(e) {
      if ((e.key === "Escape" || e.key === "Esc") && openPanel) {
        var o = opener;
        close(true);
        if (o && o.isConnected) try { o.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    // ---- hlášky ----
    function say(msg) {
      live.textContent = "";
      window.setTimeout(function () { live.textContent = msg; }, 50);
    }
    function toast(msg) {
      toastEl.textContent = msg;
      toastEl.hidden = false;
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toastEl.hidden = true; }, TOAST_MS);
    }

    // ---- přidání do košíku: klik na skutečné tlačítko, výsledek podle stránky ----
    function pageToast() {
      var t = document.querySelector(".toast");
      return t && t.classList.contains("is-show") && t.getAttribute("role") === "alert" ? t : null;
    }
    function drawerOpen() {
      return document.body.classList.contains("mini-cart--open");
    }
    function finish(ok, msg) {
      if (!pending) return;
      var p = pending;
      pending = null;
      p.mo.disconnect();
      window.clearTimeout(p.timer);
      addBtn.classList.remove("is-busy");
      addBtn.removeAttribute("aria-busy");
      if (ok) {
        addBtn.classList.add("is-added");
        addLabel.textContent = T("added");
        say(T("added"));
        window.clearTimeout(addedTimer);
        addedTimer = window.setTimeout(function () {
          addBtn.classList.remove("is-added");
          renderButton();
        }, ADDED_MS);
      } else {
        var m = msg || T("error");
        addBtn.classList.remove("is-shake");
        void addBtn.offsetWidth;
        addBtn.classList.add("is-shake");
        toast(m);
        say(m);
        renderButton();
      }
    }
    function check() {
      if (!pending) return;
      var t = pageToast();
      if (t && t !== pending.oldToast) { finish(false, t.textContent.trim()); return; }
      if (drawerOpen() && !pending.wasOpen) { finish(true); return; }
      // Tlačítko doběhlo (loading pryč) a nic z toho: výsledek dorazí ještě v témže tiku
      // (drawer se otevírá po odpovědi), proto ještě jeden krátký pohled.
      if (pending.sawLoading && !atc.classList.contains("loading")) {
        window.setTimeout(function () {
          if (!pending) return;
          var t2 = pageToast();
          if (t2 && t2 !== pending.oldToast) finish(false, t2.textContent.trim());
          else finish(true);
        }, 400);
      }
      if (atc.classList.contains("loading")) pending.sawLoading = true;
    }
    function add() {
      if (pending || addBtn.disabled) return;
      close(true);
      applyDefaultSize();
      if (atc.disabled) { renderButton(); return; }
      var old = pageToast();
      pending = {
        oldToast: old,
        wasOpen: drawerOpen(),
        sawLoading: false,
        mo: new MutationObserver(check),
        timer: window.setTimeout(function () { finish(false); }, ADD_TIMEOUT_MS)
      };
      // starou hlášku stránky ber jako vyřízenou, ať ji nová chyba pozná
      if (old) old.classList.remove("is-show");
      pending.oldToast = null;
      pending.mo.observe(atc, { attributes: true, attributeFilter: ["class", "aria-disabled", "disabled"] });
      pending.mo.observe(document.body, { attributes: true, attributeFilter: ["class"], childList: true });
      addBtn.classList.add("is-busy");
      addBtn.setAttribute("aria-busy", "true");
      atc.click();
      // Bez vybrané velikosti stránka nic neodešle a jen ukáže chybu u velikostí.
      window.setTimeout(function () {
        if (pending && !pending.sawLoading && !atc.classList.contains("loading")) {
          var err = pageQ("[data-size-err]");
          if (err && !err.hidden) finish(false, err.textContent.trim());
        }
      }, 700);
    }

    // ---- kdy je lišta vidět ----
    function styled() { return window.getComputedStyle(root).position === "fixed"; }
    function gatesOpen() {
      if (!consentOk) consentOk = consentGiven();
      return consentOk && !cookieBannerShown();
    }
    function setHeight() {
      document.documentElement.style.setProperty("--nebe-sticky-h", (on ? root.offsetHeight : 0) + "px");
    }
    function setOn(v) {
      if (v === on) return;
      on = v;
      root.classList.toggle("is-on", v);
      document.body.classList.toggle("nebe-sticky-on", v);
      if (v) {
        root.removeAttribute("inert");
        root.removeAttribute("aria-hidden");
        schedule();
      } else {
        close(true);
        root.setAttribute("inert", "");
        root.setAttribute("aria-hidden", "true");
      }
      setHeight();
    }
    function pickerVisible() {
      for (var k in pickerIn) if (pickerIn[k]) return true;
      return false;
    }
    function startTick() { if (!tick) tick = window.setInterval(sync, TICK_MS); }
    function stopTick() { if (tick) { window.clearInterval(tick); tick = null; } }
    function sync() {
      if (dead) return;
      if (!styled()) {
        // CSS se načítá bez blokování; bez něj by se lišta ukázala holá
        if (!styleTimer && styleTries < 60) {
          styleTries++;
          styleTimer = window.setTimeout(function () { styleTimer = null; sync(); }, 250);
        }
        return;
      }
      if (root.hidden) {
        root.hidden = false;
        // reflow, ať první vyjetí dostane přechod a neobjeví se skokem
        void root.offsetWidth;
        schedule();
      }
      // Mobil (David, 10. 10. 2026): lišta je vidět hned od načtení, nečeká na odjetí tlačítka
      // ani na cookie lištu (ta má vyšší vrstvu a lištu případně jen překryje).
      // Když má ale výběr barvy nebo velikosti na obrazovce přímo ve stránce, lišta by ho
      // jen zdvojovala a zakrývala: schová se a po odjetí výběru zase vyjede (David, 10. 10.).
      if (!mq.matches) { setOn(!pickerVisible()); stopTick(); return; }
      if (!atcOut) { setOn(false); stopTick(); return; }
      var open = gatesOpen();
      setOn(open);
      if (open) stopTick(); else startTick();
    }

    function destroy() {
      dead = true;
      stopTick();
      close(true);
      if (io) io.disconnect();
      if (io2) io2.disconnect();
      if (mo) mo.disconnect();
      if (ro) ro.disconnect();
      if (pending) { pending.mo.disconnect(); window.clearTimeout(pending.timer); pending = null; }
      document.removeEventListener("keydown", onKey);
      document.body.classList.remove("nebe-sticky-on");
      document.documentElement.style.setProperty("--nebe-sticky-h", "0px");
      if (root.parentNode) root.remove();
      if (current && current.root === root) current = null;
    }

    // ---- napojení ----
    dd.addEventListener("click", function () { toggle("size", dd); });
    addBtn.addEventListener("click", add);
    qtyDec.addEventListener("click", function () { stepQty(-1); });
    qtyInc.addEventListener("click", function () { stepQty(1); });
    qtyWrap.addEventListener("animationend", function () { qtyWrap.classList.remove("is-shake"); });
    arr(root.querySelectorAll("[data-nebe-sticky-close]")).forEach(function (b) {
      b.addEventListener("click", function () { close(); });
    });
    if (guide) guide.addEventListener("click", function () {
      var a = pageQ("[data-size-open]");
      close(true);
      if (a) a.click();
    });
    document.addEventListener("keydown", onKey);

    // Formulář (ne samotné tlačítko): u vyprodané varianty stránka schová řádek s tlačítkem
    // a observer by pak hlásil „mimo obraz" i nahoře u výběru.
    io = new IntersectionObserver(function (entries) {
      atcOut = !entries[entries.length - 1].isIntersecting;
      sync();
    }, { threshold: 0 });
    io.observe(formWrap);

    // Mobil: výběr barvy a velikosti ve stránce. Spodní okraj se zmenší o výšku lišty, aby
    // kolečka schovaná pod lištou nepočítala jako vidět; jinak by lišta zmizela dřív, než je
    // zákaznice uvidí. Pevná hodnota, ne --nebe-sticky-h: ta je 0, když je lišta schovaná,
    // a hranice by poskakovala.
    io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { pickerIn[e.target.getAttribute("data-nebe-pick")] = e.isIntersecting; });
      sync();
    }, { threshold: 0, rootMargin: "0px 0px -72px 0px" });
    [["color", pageQ("[data-swatches]")], ["size", pageQ("[data-sizes]")]].forEach(function (p) {
      if (!p[1]) return;
      p[1].setAttribute("data-nebe-pick", p[0]);
      io2.observe(p[1]);
    });

    mo = new MutationObserver(schedule);
    [pageQ("[data-swatches]"), pageQ("[data-sizes]"), pageQ("[data-color-name]"), pageQ("[data-price-now]"),
     pageQ("[data-price-old]"), pageQ("[data-bundles]")].forEach(function (n) {
      if (n) mo.observe(n, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["class", "aria-pressed"] });
    });
    mo.observe(atc, { attributes: true, attributeFilter: ["disabled"], childList: true, subtree: true, characterData: true });
    mo.observe(page, { attributes: true, attributeFilter: ["class"] });
    // Stepper ve stránce: jeho číslo je value inputu, to MutationObserver nevidí. U multibuy
    // se při změně počtu překreslí [data-bundles] (sledované výš), u podprsenek nic, proto
    // i události přímo na stepperu (klik na − / +, dopsané číslo potvrzené blur/Enter).
    var pq = pageQty();
    if (pq) {
      mo.observe(pq, { childList: true, subtree: true });
      ["click", "change", "focusout"].forEach(function (t) { pq.addEventListener(t, schedule); });
    }

    // Výška lišty pro okolí (kartička akce, padding stránky) a počet koleček podle šířky.
    if ("ResizeObserver" in window) {
      var lastW = 0;
      ro = new ResizeObserver(function () {
        if (on) setHeight();
        var w = swWrap.clientWidth;
        if (w !== lastW) { lastW = w; schedule(); }
      });
      ro.observe(root);
      ro.observe(inner);
      ro.observe(swWrap);
    }
    if (mq.addEventListener) mq.addEventListener("change", function () { close(true); schedule(); sync(); });

    render();
    sync();
    return { root: root, section: sid, destroy: destroy };
  }

  function boot() {
    var els = document.querySelectorAll("[data-nebe-sticky]");
    var fresh = null;
    for (var i = 0; i < els.length; i++) {
      if (els[i].hasAttribute("data-nebe-sticky-ready")) continue;
      // Kdyby se snippet vykreslil dvakrát, platí poslední.
      if (fresh) fresh.remove();
      fresh = els[i];
    }
    if (!fresh) return;
    fresh.setAttribute("data-nebe-sticky-ready", "");
    if (current) current.destroy();
    current = Sticky(fresh);
  }

  window.NEBE_STICKY = { boot: boot };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Editor motivu: sekce se přerenderuje s novou lištou, stará visí v body.
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:unload", function (e) {
    if (current && e.detail && current.section === e.detail.sectionId) current.destroy();
  });
})();
